// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__xvWVc","desabilitar":"OptionSelect_desabilitar__X5D3F","focado":"OptionSelect_focado__eKPdC","novo":"OptionSelect_novo__AR6GE"};